:host {
  width: 100%;
  height: 100%;

  * {
    &::-webkit-scrollbar {
      width: 10px;
      left: -100px;
    }

    &::-webkit-scrollbar-track {
        background-color: var(--vt-color-grey-lighter, #EDEDEC);
        border-top-right-radius: .25rem;
        border-bottom-right-radius: .25rem;
        border-top-left-radius: .25rem;
        border-bottom-left-radius: .25rem;
    }

    &::-webkit-scrollbar-thumb {
        background-color: var(--vt-color-grey-light, #A5A5A2);
        border-radius: 8px;
        border: solid 2px transparent;
        background-clip: content-box;
    }

    scrollbar-color: var(--vt-color-grey-light, #A5A5A2);
    scrollbar-width: thin;
  }
}

::slotted([slot=stage][hidden]) {
  @apply hidden;
}

::slotted([slot=stage]:not([hidden])) {
  @apply block h-[547px];
}

::slotted([slot=search]:not([hidden])) {
  @apply h-[100px] flex items-center;
}

::slotted([slot=social-media-items]) {
  @apply fill-grey transition-transform ease-linear duration-[.25s];
}

::slotted([slot=social-media-items]:hover) {
  @apply scale-[1.2];
}
